// extracted by mini-css-extract-plugin
export var darkBackground = "navbar-module--darkBackground--eb2cd";
export var hamburgerMenu = "navbar-module--hamburgerMenu--63597";
export var header = "navbar-module--header--ca8c3";
export var logo = "navbar-module--logo--a4da1";
export var mobileBtn = "navbar-module--mobileBtn--9d209";
export var mobileNavOpen = "navbar-module--mobileNavOpen--bcd4d";
export var navbar = "navbar-module--navbar--55017";
export var rightnav = "navbar-module--rightnav--29a23";
export var solidwhite = "navbar-module--solidwhite--c61fa";